/**
 * DeleteButton component for removing a flashcard.
 * Shows spinner during deletion.
 *
 * @param {Object} props - Component props
 * @param {Function} props.onClick - Callback when button is clicked
 * @param {boolean} props.isDeleting - Whether deletion is in progress
 * @param {string} [props.label] - Accessible label for the button
 * @returns {React.ReactElement} Delete button
 */
export default function DeleteButton({
  onClick,
  isDeleting,
  label = 'Usuń fiszkę',
}) {
  return (
    <button
      type="button"
      className="delete-button"
      onClick={onClick}
      disabled={isDeleting}
      aria-label={label}
      aria-busy={isDeleting}
    >
      {isDeleting ? (
        <span className="delete-button__spinner" aria-hidden="true"></span>
      ) : (
        <span className="delete-button__icon" aria-hidden="true">
          ×
        </span>
      )}
    </button>
  )
}
